import { useAuth } from "@context/AuthContext";

/**
 * Hook to check whether the current user has the Traffic Manager role.
 * Returns false when no user is logged in.
 */
export const useIsTrafficManager = (): boolean => {
    const { user } = useAuth();
    return user?.role === "tm";
};
